import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';
import { environment } from '@/env/environment';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-maintenance-standalone',
    templateUrl: './maintenance-standalone.component.html',
    styleUrls: ['./maintenance-standalone.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MaintenanceStandaloneComponent {
    public currentLanguage: 'en' | 'es' = 'es';
    public currentLangtxt = 'Español';
    public idiomaChange = 'Inglés';
    public isLangOpen = false;
    public env = environment;

    constructor(
        private readonly getLanguageUseCase: TranslationsGetLanguageUseCase,
    ) {
        this.currentLanguage = this.getLanguageUseCase.execute().language;
        this.currentLangtxt =
            this.currentLanguage === 'en' ? 'English' : 'Español';
        this.idiomaChange = this.currentLanguage === 'en' ? 'Spanish' : 'Inglés';
    }

    public toggleLang(event: Event): void {
        event.stopPropagation();
        this.isLangOpen = !this.isLangOpen;
    }
}
